export class UriService {
    parseQueryParams(query) {
        if (query.length === 0) {
            return {};
        }
        const objStr = '{"' + decodeURI(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}';
        return JSON.parse(objStr);
    }
}
